import EmbeddedFormPage from './EmbeddedFormPage';

const PayrollPage = () => (
  <EmbeddedFormPage
    titleKey="Payroll"
    description="Fill out this form to get started with payroll services for your Wonderschool program."
    formUrl="https://wonderschool.fillout.com/t/qnCkqN8iLpus"
  />
);

export default PayrollPage;
